import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

@Injectable()
export class SnackBarService {
    constructor(private snackBar: MatSnackBar, private router: Router) {}

    working(message: string, panelClass = "snackbar-success") {
        this.snackBar.open(message, "", {
            panelClass: [panelClass],
            verticalPosition: "bottom",
        });
    }

    success(message: string) {
        this.snackBar.open(message, "OK", {
            duration: 4000,
            panelClass: ["snackbar-success"],
            verticalPosition: "bottom",
        });
    }

    successAssignmentCompletion(message: string, courseID: number) {
        const snackbarRef = this.snackBar.open(message, "OK", {
            duration: 8000,
            panelClass: ["snackbar-success"],
            verticalPosition: "bottom",
        });
    }

    successAssignmentPartialCompletion(message: string) {
        const snackbarRef = this.snackBar.open(message, "OK", {
            duration: 8000,
            panelClass: ["snackbar-success"],
            verticalPosition: "bottom",
        });
    }

    error(message: string) {
        const outputMessage = message; // + ' IF THE PROBLEM PERSISTS, PLEASE CONTACT SUPPORT.';
        const snackbarRef = this.snackBar.open(
            outputMessage,
            "CONTACT SUPPORT",
            {
                duration: 8000,
                panelClass: ["snackbar-error"],
                verticalPosition: "bottom",
            }
        );

        snackbarRef.onAction().subscribe(() => {
            window.open(
                "https://www.carnegielearning.com/lets-talk/#support",
                "_blank"
            );
            // this.router.navigate(["/support"]); // updated with the external support link above
        });
    }

    prompt(message: string, buttonText: string, callbackFunction: Function) {
        const snackbarRef = this.snackBar.open(message, buttonText, {
            duration: 12000,
            panelClass: ["snackbar-success"],
            verticalPosition: "bottom",
        });

        snackbarRef.onAction().subscribe(() => {
            callbackFunction();
        });
    }
}
